import { CHAIN_ID, EXPLORER_URL } from "@src/constants";

export function getExplorerLink(txId: string) {
  if (CHAIN_ID === "W" || CHAIN_ID === "R") {
    return `${EXPLORER_URL}/tx/${txId}`;
  }

  return `${EXPLORER_URL}/tx/${txId}?network=testnet`;
}